module.exports = __webpack_public_path__ + "static/media/g4.226b2a0f.jpg";